import * as Tokens from '@wisereducacao-npm/design-system-tokens/dist/esm/conquer-unna/dark/dark';

import {
  border,
  font as globalFontStyles,
  lineHeight,
  opacity,
  shadow,
  spacing,
} from '../global';

const color = {
  primary: {
    dark: Tokens.ColorPrimaryDark,
    light: Tokens.ColorPrimaryLight,
    medium: Tokens.ColorPrimaryMedium,
    pure: Tokens.ColorPrimaryPure,
  },
  secondary: {
    dark: Tokens.ColorSecondaryDark,
    light: Tokens.ColorSecondaryLight,
    medium: Tokens.ColorSecondaryMedium,
    pure: Tokens.ColorSecondaryPure,
  },
  neutral: {
    button: Tokens.NeutralColorButton,
    highContrast: Tokens.NeutralColorHighContrast,
    lowContrast: Tokens.NeutralColorLowContrast,
    mediumContrast: Tokens.NeutralColorMediumContrast,
    pure: Tokens.NeutralColorPure,
  },
  feedback: {
    success: {
      highContrast: Tokens.FeedbackColorSuccessHighContrast,
      lowContrast: Tokens.FeedbackColorSuccessLowContrast,
      mediumContrast: Tokens.FeedbackColorSuccessMediumContrast,
      pure: Tokens.FeedbackColorSuccessPure,
    },
    alert: {
      highContrast: Tokens.FeedbackColorAlertHighContrast,
      lowContrast: Tokens.FeedbackColorAlertLowContrast,
      mediumContrast: Tokens.FeedbackColorAlertMediumContrast,
      pure: Tokens.FeedbackColorAlertPure,
    },
    error: {
      highContrast: Tokens.FeedbackColorErrorHighContrast,
      lowContrast: Tokens.FeedbackColorErrorLowContrast,
      mediumContrast: Tokens.FeedbackColorErrorMediumContrast,
      pure: Tokens.FeedbackColorErrorPure,
    },
    button: Tokens.FeedbackColorButton,
  },
};

const font = {
  ...globalFontStyles,
  family: {
    primary: Tokens.FontFamilyPrimary,
  },
};

export const conquerUnna = {
  color,
  spacing,
  font,
  lineHeight,
  border,
  opacity,
  shadow,
  data: {
    dsProductId: 'conquer-unna',
    dsMode: 'dark',
    business: 'conquer-unna',
    productCode: 'cunna-eflm',
    lead: {
      sendBffLeadRequest: {
        route: false,
        planType: true,
      },
    },
    logoFile: 'logo-conquer-unna.png',
    isThemeUsingAllDsTokens: true,
    isTermsAndPoliticsAvailable: true,
    isProductFlowsAvailable: true,
    googleTagManagerId: '',
    stepsNumber: 4,
    lang: 'pt-BR',
    product: {
      name: 'Conquer Unna',
      businessName: 'Conquer Unna',
    },
    faqLink: 'https://cnqr.com.br/r/CX-WhatsApp/',
    links: {
      test: {
        domain: 'https://conquerplus.com.br/login',
        firstAccess: 'https://conquerplus.com.br/login?token=${token}',
        terms:
          'https://drive.conqueronline.com.br/core/Contratos-Checkout/Contrato_Conquer_Plus1.pdf',
        politics:
          'https://escolaconquer.com.br/POL%C3%8DTICA_DE_PRIVACIDADE_E_COOKIES-CONQUER.pdf',
      },
      homolog: {
        domain: 'https://conquerplus.com.br/login',
        firstAccess: 'https://conquerplus.com.br/login?token=${token}',
        terms:
          'https://drive.conqueronline.com.br/core/Contratos-Checkout/Contrato_Conquer_Plus1.pdf',

        politics:
          'https://escolaconquer.com.br/POL%C3%8DTICA_DE_PRIVACIDADE_E_COOKIES-CONQUER.pdf',
      },
      production: {
        domain: 'https://conquerplus.com.br/login',
        firstAccess: 'https://conquerplus.com.br/login?token=${token}',
        terms:
          'https://drive.conqueronline.com.br/core/Contratos-Checkout/Contrato_Conquer_Plus1.pdf',

        politics:
          'https://escolaconquer.com.br/POL%C3%8DTICA_DE_PRIVACIDADE_E_COOKIES-CONQUER.pdf',
      },
    },
    payment: {
      currentStep: 3,
      cardCompanies: [
        { value: 'american_express', name: 'Amex' },
        { value: 'visa', name: 'Visa' },
        { value: 'mastercard', name: 'Mastercard' },
        { value: 'elo', name: 'Elo' },
        { value: 'diners', name: 'Diners' },
      ],
      planTypes: {
        yearly: 'yearly',
        recurrency: 'recurrency',
      },
      sendBffPaymentRequest: {
        documentToNFGeneration: true,
      },
      productDsIcon: 'user',
    },
    pix: {
      currentStep: 3,
    },
    success: {
      finalSuccess: {
        displayHeader: {
          bankslip: true,
          default: false,
        },
        displayIcon: true,
        displayAccessButton: false,
      },
      upsellOffer: {
        displayHeader: true,
        upsellVIdeoPresentation: false,
        displayUpsellThemeOnOfferCard: true,
      },
    },
  },
  style: {
    form: {
      maxWidth: '485px',
    },
    assets: {
      logo: {
        file: 'logo-conquer-unna.png',
        width: '170px',
      },
      favicon: 'favicon-conquer-unna.png',
      loading: 'rolling-conquer-unna.svg',
    },
  },
  text: {
    sellerBox: 'Atendimento:',
    lead: {
      text: 'Informe seus dados',
      description:
        'Complete suas informações para prosseguir para o pagamento.',
      button: 'Continuar',
      labels: {
        name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Celular',
      },
      placeholder: {
        name: 'Ex: João Silva',
        email: 'Ex: seuemail@gmail.com',
        phone: 'Ex: 99 99999 9999',
      },
    },
    payment: {
      title: 'Pagamento',
      description:
        'Você está prestes a adquirir o <b class="no-line-break-word">{PRODUCT_NAME}</b>. Escolha a forma de pagamento para concluir sua compra.',
      button: 'Confirmar pagamento',
      labels: {
        installments: 'Selecione o número de parcelas',
        cardCompany: 'Selecione sua bandeira',
        cardName: 'Nome do titular',
        cardNumber: 'Número do cartão',
        cardExpireDate: 'Data de validade',
        cardCVV: 'CVV',
        cpf: 'CPF para emissão da nota fiscal',
      },
      placeholder: {
        cardCompany: 'Selecione',
        cardName: 'Ex: João Silva',
        cardNumber: '**** **** **** ****',
        cardExpireDate: 'MM/AA',
        cardCVV: 'xxx',
      },
    },
    success: {
      bankslip: {
        title: 'Quase lá!',
        subtitle:
          'Seu boleto já está disponível para pagamento. Você pode acessá-lo abaixo. <br /> <br /> Em até 2 dias após a confirmação do pagamento, você receberá um e-mail para finalizar seu cadastro. <br /><br /><br />',
        icon: 'smiley',
        button: {
          text: 'Ver boleto',
        },
      },
      default: {
        title: 'Matrícula realizada com sucesso!',
        subtitle: '',
        offerMessage:
          'Mas antes veja essa oportunidade que preparamos exclusivamente para você!',
        icon: 'check_circle',
        button: {
          text: '',
        },
      },
      successMessage: {
        title: 'Tudo certo!',
        subtitle:
          'Você garantiu o seu acesso ao <b class="no-line-break-word">{MAIN_PRODUCT_NAME}</b>',
        icon: 'cicle_check',
      },
      successMessageUpsell: {
        title: 'Tudo certo!',
        subtitle:
          'Você garantiu o seu acesso ao <b class="no-line-break-word">{MAIN_PRODUCT_NAME}</b> e ao <b class="no-line-break-word">{UPSELL_PRODUCT_NAME}</b>. Clique no botão abaixo para concluir seu cadastro de aluno e ter acesso a plataforma.<br /><br /><br />',
        icon: 'check_circle',
        button: {
          text: 'Acessar o {MAIN_PRODUCT_NAME}',
        },
      },
    },
  },
} as const;
